<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <a v-bind:href="helper.WEB_URL + '/reverseStopBillForm'" class="btn btn-rounded btn-primary btn-block-xs-only"> 
            New Reverse Stop Bill 
          </a>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppFilterDateRange
        v-show="false"
        ref="dateRangeFilter" 
        v-on:filter-data-change="onFilterDateChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PASSCARD_PARAM"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <TemplateButton slot="modal-footer-after" @click="onIssuePasscardClick" type="button" class="btn btn-success">
          Assign Passcard
        </TemplateButton>
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_type',
    text: 'Type',
    form_hide: true, 
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem['_licenseID']}">${helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum'])}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
    form_hide: true, 
  },
  {
    key: 'parkerID',
    text: 'Parker ID',
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'date1',
    text: 'Reverse Stop Bill Date',
    table_custom: helper.tableCustomDate
  },
  {
    key: 'data1',
    text: 'Reason',
  },
  {
    key: 'createDate',
    text: 'Created Date',
    table_custom: helper.tableCustomDatetime
  },
  {
    key: 'data2',
    text: 'Created By',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);


const PASSCARD_PARAM = [
  {
    key: '_carparkName',
    text: 'Car Park',
    form_input_attr: { disabled: true },
  },
  {
    key: 'passcardID',
    text: 'Passcard Number',
    form_select: {
      data: [],
      formatSelectOptionText: k => k.option,
    },
    form_select_sort: function(temp) {
      temp.sort((a, b) => a.createDate - b.createDate);
    },
  },
];
const PASSCARD_PARAM_MAP = helper.transformParamToMap(PASSCARD_PARAM);

export default {
  name: "PageReverseStopBill",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Management' },
        { name: 'Reverse Stop Bill' },
      ],

      PARAM,
      PARAM_MAP,

      PASSCARD_PARAM,
      PASSCARD_PARAM_MAP,

      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageParker: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    // if(!helper.hasEditPermission(this.permission)) {
    //   this.PARAM_MAP['test2'].table_hide = true;
    // }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }

      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park application data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          let selection = this.pageCarpark;
          selection = [].concat({name: 'All Car Parks'}, selection);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(selection, this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;

          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });

          if(response.data && response.data.length > 0) {
            // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);
            this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);
            this.loadLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      
      let url = helper.SERVER_URL + '/api2/request?type1=reactivation';
      if(this.$refs['licenseFilter'].filterValue) {
        url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let feedbackItem = 'request data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage('');
            // TODO kw1 hasPasscardID=0 doesn't work, hasPasscardID=1 does
            this.pageLease = response.data;
            // this.pageLease = this.pageLease.filter(k => !k.passcardID);
            this.pageLease.sort((a, b) => b.createDate - a.createDate);
              
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No lease data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      let startDate = this.$refs['dateRangeFilter'].filterDateStart.unix();
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd.unix();

      this.pageLease = this.pageLease.filter(k => {
        if(k['date1'] < startDate) {
          // return false
        }
        if(k['date1'] > endDate) {
          // return false
        }

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        // if(!k['_product'] || k['_product']['isPriority']) {
        //   return false;
        // }

        k['_productName'] = (k['_product'] || {}).name;
        
        k['_license'] = this.$refs['licenseFilter'].filterData.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_type'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        // k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        // k['_zoneName'] = (k['_zone'] || {}).name;

        return true;
      });
      
      this.$refs['pageTable'].setTableData(this.pageLease, this.$refs['pageTable'].getCurrentPage());
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let license = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      let url = helper.SERVER_URL + '/api2';
      if(license && license['_customer']) {
        url += '/customer/' + license['_customer']['id']
      }
      url += '/parker';

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onTablePageChange() {
      this.loadLease();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLease();
    },
    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },
    onFilterDateChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },

    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      let availablePasscard = this.pagePasscard.filter(k => helper.compareID(k.carparkID, tableData[tableDataIndex]['_carpark']['id']));
      helper.inputSelectSetOption(this.PASSCARD_PARAM_MAP['passcardID'], availablePasscard);
      this.$refs['pageModal'].setModalOpen(false, 'Issue Passcard', tableData[tableDataIndex]);
    },

    async onIssuePasscardClick() {
      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;

      // TODO kw1 update passcard status - if update without original passcard attribute will reset passcard

      let feedbackItem = 'passcard status';
      this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
      let result = await this.$http
        .put(
          helper.SERVER_URL + '/api2/passcard/' + formData['passcardID'],
            querystring.stringify({
              movement: 'Issued',
              carparkID: formData['_carparkNum']
            }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return true;
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
        });

      if(result) {
        feedbackItem = 'lease passcard';
        this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
        this.$http
          .put(
            helper.SERVER_URL + '/api2/carpark/' + formData['_carparkNum'] + '/lease/' + formData['id'],
            querystring.stringify({
              passcardID: formData['passcardID'],
              passcardIssueDate: new moment().unix()
            }),
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageModal'].setModalClose();
            this.$refs['pageTable'].setTableData(this.pageLease = null);
            this.loadPasscard();
          })
          .catch(error => {
            this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/BillManagement/PageReverseStopBill.vue